import dayjs from 'dayjs'
import { toFixed, toThousands } from './number'
import BigNumber from 'bignumber.js'

export const formatTime = (time: string | number) => {
  return dayjs(time).format('YYYY.MM.DD HH:mm:ss')
}
export const formatTime2 = (time: string | number) => {
  return dayjs(time).format('YYYY.MM.DD')
}
export const formatUSD = (usd: string | number, precision = 2) => {
  return toThousands(toFixed(usd, precision, BigNumber.ROUND_DOWN, false))
}
